import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "app/auth/service";
import { UtilsService } from "app/auth/service/utils.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ProductsService } from "../../products.service";
import moment from "moment";
import { IProductCost } from "../../models/products";

@Component({
  selector: "app-products-cost-list",
  templateUrl: "./products-cost-list.component.html",
  styleUrls: ["./products-cost-list.component.scss"],
})
export class ProductsCostListComponent implements OnInit {
  public contentHeader: IContentHeader = null;
  public searchKey: string = "";
  public tableLimit: number = 10;
  public productsList: IProductCost[] = [];
  public filterProductsList: IProductCost[] = [];
  public selectedProduct: IProductCost[] = null;
  public availableMonths: string[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
  public availableYears: string[] = [];
  public selectedYear: string = moment().format("YYYY");
  public selectedMonth: string = moment().format("M");

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private router: Router,
    private _productsService: ProductsService,
    private _changeDetectorRef: ChangeDetectorRef,
  ) {
    this.contentHeader = {
      headerTitle: "MENU.PRODUCTS_COSTS",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "PRODUCTS",
            isLink: false,
          },
          {
            name: "MENU.PRODUCTS_COSTS",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    for (let i: number = 2023; i <= Number(this.selectedYear); i++) {
      this.availableYears.push(String(i));
    }
    if (!this._authenticationService.hasCapability("show_menu_products_costs")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this.loadProducts();
  }

  async loadProducts() {
    if (Number(this.selectedMonth) > Number(moment().format("M")) && Number(this.selectedYear) >= Number(moment().year())) {
      await this._utilService.showSWALError({ text: "ERROR_VIEW_FUTURE_COST" });

      this.selectedMonth = moment().format("M");
      this.selectedYear = moment().format("YYYY");
      this._changeDetectorRef.detectChanges();
      return false;
    }
    this.productsList = await this._productsService.getProductsCostList(this.selectedMonth, this.selectedYear);
    this.search();
  }

  updateTableLimit(event: { target: { value: string } }): void {
    this.tableLimit = Number(event.target.value);
  }

  search() {
    let filteredArray: IProductCost[] = this.productsList;

    if (this.searchKey && this.searchKey.length > 0) {
      const key: string = this.searchKey.toLowerCase();
      filteredArray = filteredArray.filter((product: IProductCost) => product.name.toLowerCase().includes(key));
    }
    this.filterProductsList = filteredArray;
  }

  formatLabel(month: number) {
    //Refactor della label filtro mese
    const date = moment();
    date.set("month", month - 1);
    return date.format("MMMM");
  }

  formatPrice(cost: IProductCost) {
    cost.new_monthly_cost = this._utilService.addDotsToNumber(cost.new_monthly_cost);
  }

  openEdit(cost: IProductCost) {
    cost.editCost = true;
    cost.new_monthly_cost = this._utilService.addDotsToNumber(cost.monthly_cost);
  }

  cancelEdit(cost: IProductCost) {
    cost.editCost = false;
    cost.new_monthly_cost = null;
  }

  async updateCost(cost: IProductCost) {
    this._utilService.showLoading();
    if (!this._authenticationService.hasCapability("manage_products_costs")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (!cost.new_monthly_cost) {
      this._utilService.hideLoading();
      this._utilService.showSWALError({ text: "ERROR_INSERT_COST" });
      return false;
    }

    let data: { monthly_cost: string } = {
      monthly_cost: cost.new_monthly_cost,
    };
    this._productsService
      .updateCost(cost.id, data)
      .then(async () => {
        this._utilService.hideLoading();
        await this.loadProducts();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_PRODUCT_COST" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_UPDATE_PRODUCT_COST" });
      });
  }
}
